




























import {
  defineComponent
} from '@nuxtjs/composition-api';
import { useImage } from '@wemade-vsf/composables';
import { SfButton } from '@storefront-ui/vue';

export default defineComponent({
  name: 'AttachmentDownload',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    attachment: {
      type: String,
      default: ''
    }
  },
  components: {
    SfButton
  },
  setup (props) {
    const { getMagentoImage } = useImage();

    const download = () => {
      if (process.server) return
      window.open(props.attachment)
    }

    return {
      download,
      getMagentoImage
    }
  }
})
